import {
    buildUrl,
    formatParam,
} from "../util/integration";


const normalizeValue = (value) => {
    if (
        value === null
        || value === undefined
    ) {
        return "";
    }

    return String(value);
};


const validationUrl = (
    endpoint,
    value,
) => {
    return buildUrl(
        `validation/${endpoint}`
        + `?str=${formatParam(
            normalizeValue(value),
        )}`,
    );
};


const validateByGet = (
    endpoint,
    value,
) => {
    return fetch(
        validationUrl(
            endpoint,
            value,
        ),
    );
};


/**
 * GET /validation/possiblyEmptyAlphanumericStr
 */
export const validatePossiblyEmptyAlphanumericString = (
    str,
) => {
    return validateByGet(
        "possiblyEmptyAlphanumericStr",
        str,
    );
};


/**
 * GET /validation/possiblyEmptyAlphanumericText
 */
export const validatePossiblyEmptyAlphanumericText = (
    str,
) => {
    return validateByGet(
        "possiblyEmptyAlphanumericText",
        str,
    );
};


/**
 * GET /validation/nonEmptyAlphanumericStr
 */
export const validateNonEmptyAlphanumericString = (
    str,
) => {
    return validateByGet(
        "nonEmptyAlphanumericStr",
        str,
    );
};


/**
 * Es gibt im ValidationController keinen eigenen
 * /nonEmptyAlphanumericText-Endpunkt.
 *
 * Deshalb wird lokal zuerst geprüft, ob der Wert leer ist.
 * Ist er nicht leer, wird der vorhandene
 * possiblyEmptyAlphanumericText-Endpunkt verwendet.
 */
export const validateNonEmptyAlphanumericText = (
    str,
) => {
    const normalized =
        normalizeValue(str);

    if (
        normalized.trim() === ""
    ) {
        return Promise.resolve(
            new Response(
                JSON.stringify(false),
                {
                    status: 200,
                    headers: {
                        "Content-Type":
                            "application/json",
                    },
                },
            ),
        );
    }

    return validatePossiblyEmptyAlphanumericText(
        normalized,
    );
};


/**
 * GET /validation/possiblyEmptyPhoneNumber
 */
export const validatePossiblyEmptyPhoneNumber = (
    str,
) => {
    return validateByGet(
        "possiblyEmptyPhoneNumber",
        str,
    );
};


/**
 * GET /validation/nonEmptyPhoneNumber
 */
export const validateNonEmptyPhoneNumber = (
    str,
) => {
    return validateByGet(
        "nonEmptyPhoneNumber",
        str,
    );
};


/**
 * GET /validation/nonEmptyDEMobilePhoneNumber
 *
 * Bestehender Exportname wird aus Kompatibilitätsgründen
 * beibehalten.
 */
export const validateNonDEMobileEmptyPhoneNumber = (
    str,
) => {
    return validateByGet(
        "nonEmptyDEMobilePhoneNumber",
        str,
    );
};


/**
 * Zusätzlich korrekt benannter Alias.
 */
export const validateNonEmptyDEMobilePhoneNumber =
    validateNonDEMobileEmptyPhoneNumber;


/**
 * GET /validation/possiblyEmptyEmailAddress
 */
export const validatePossiblyEmptyEmailAddress = (
    str,
) => {
    return validateByGet(
        "possiblyEmptyEmailAddress",
        str,
    );
};


/**
 * GET /validation/nonEmptyEmailAddress
 */
export const validateNonEmptyEmailAddress = (
    str,
) => {
    return validateByGet(
        "nonEmptyEmailAddress",
        str,
    );
};


/**
 * GET /validation/nonEmptyHouseNo
 */
export const validateNonEmptyHouseNo = (
    str,
) => {
    return validateByGet(
        "nonEmptyHouseNo",
        str,
    );
};


/**
 * GET /validation/possiblyEmptyHouseNo
 */
export const validatePossiblyEmptyHouseNo = (
    str,
) => {
    return validateByGet(
        "possiblyEmptyHouseNo",
        str,
    );
};


/**
 * GET /validation/nonEmptyZipCode
 */
export const validateNonEmptyZipCode = (
    str,
) => {
    return validateByGet(
        "nonEmptyZipCode",
        str,
    );
};


/**
 * GET /validation/possiblyEmptyZipCode
 */
export const validatePossiblyEmptyZipCode = (
    str,
) => {
    return validateByGet(
        "possiblyEmptyZipCode",
        str,
    );
};


/**
 * GET /validation/possiblyEmptyUstID
 */
export const validatePossiblyEmptyUstID = (
    str,
) => {
    return validateByGet(
        "possiblyEmptyUstID",
        str,
    );
};


/**
 * GET /validation/possibleEmptyStripeAccountId
 *
 * Achtung:
 * Der Backend-Endpunkt heißt "possibleEmptyStripeAccountId"
 * und NICHT "possiblyEmptyStripeAccountId".
 */
export const validatePossiblyEmptyStripeAccountId = (
    str,
) => {
    return validateByGet(
        "possibleEmptyStripeAccountId",
        str,
    );
};


/**
 * GET /validation/any
 */
export const validateAcceptAny = (
    str,
) => {
    return validateByGet(
        "any",
        str,
    );
};


/**
 * POST /validation/password
 *
 * Das Passwort wird als plain-text Request-Body übertragen.
 */
export const validatePassword = (
    str,
) => {
    return fetch(
        buildUrl(
            "validation/password",
        ),
        {
            method: "POST",
            headers: {
                "Content-Type":
                    "text/plain",
            },
            body:
                normalizeValue(str),
        },
    );
};